import Autolinker from "autolinker";

import Api from "@/Api";
import "./style.css";

const delay = t => new Promise(resolve => setTimeout(resolve, t));

export default class TextSocial {
  static selector = ".text";

  constructor(block) {
    this.block = block;
    this.socialContainer = this.block.querySelector(".text__social");
    this.tweetContainer = this.block.querySelector(".text__tweet");
    if(this.tweetContainer) {
      this.tweetText = this.tweetContainer.querySelector(
        ".text__tweet-text"
      );
      this.tweetPicture = this.tweetContainer.querySelector(
        ".text__tweet-picture"
      );

      this.loadTweets();      
    }
  }

  ellipsizeTweet = async () => {
    if(!this.tweetContainer) {
      return;
    }
    if (!this.tweetText.originalWords) {
      this.tweetText.originalWords = this.tweetText.innerText.split(" ");
    } else {
      this.tweetText.innerHTML = Autolinker.link(
        this.tweetText.originalWords.join(" "),
        {
          hashtag: "twitter",
          mention: "twitter"
        }
      );
    }
    const wordArray = [...this.tweetText.originalWords];
    while (this.tweetText.scrollHeight > this.tweetText.offsetHeight) {
      wordArray.pop();
      this.tweetText.innerHTML = Autolinker.link(
        wordArray.join(" ") + "&hellip;",
        {
          hashtag: "twitter",
          mention: "twitter"
        }
      );
    }
  };

  async loadTweets() {
    try {
      this.tweets = await Api.fetchTweets();

      if (this.tweets.errors) {
        throw new Error(this.tweets.errors[0]);
      }

      this.tweets = this.tweets.slice(0, 4);
      this.currentTweet = 0;

      if (!this.tweets.length) {
        return;
      }

      // show tweets
      this.setCurrentTweet(this.tweets[this.currentTweet]);

      setInterval(() => {
        this.currentTweet = (this.currentTweet + 1) % this.tweets.length;
        this.setCurrentTweet(this.tweets[this.currentTweet]);
      }, 60000);
    } catch (e) {
      // TODO: handle error
      console.log("twitter error", e);
      this.tweetContainer.classList.add("text__tweet--error");
    }
  }

  setCurrentTweet(tweet) {
    this.tweetContainer.classList.add("text__tweet--changing");

    setTimeout(() => {
      this.tweetText.originalWords = tweet.full_text.split(" ");
      this.ellipsizeTweet();

      if (tweet.entities.media && tweet.entities.media.length > 0) {
        const media = tweet.entities.media[0];
        // const imageHeight = media.sizes.large.h;
        this.tweetPicture.style.backgroundImage = `url(${media.media_url_https})`;
        this.tweetPicture.classList.remove(
          "text__tweet-picture--missing"
        );
        this.socialContainer.classList.add(
          "text__social--with-picture"
        );
      } else {
        this.tweetPicture.classList.add(
          "text__tweet-picture--missing"
        );
        this.socialContainer.classList.remove(
          "text__social--with-picture"
        );
      }

      this.tweetContainer.classList.remove("text__tweet--changing");
    }, 500);
  }

  onResize = () => {
    this.ellipsizeTweet();
  };
}
